import React from 'react'
import ReactDOM from 'react-dom'
import CompanyPages from './companypages'
import { store } from '../../store' 

$.fn.companypages = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(CompanyPages, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-companypages]').companypages();
});